import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getProjectDocs } from './api_project';

const initialState = {};

export const fetchProjectDocumentsData = createAsyncThunk(
  'ui/fetchProjectDocumentsData',
  async (obj, thunkAPI) => {
    const { getState } = thunkAPI;
    const response = await getProjectDocs(obj);
    return response.data;
  }
);

const projectDocumentsSlice = createSlice({
  name: 'projectDocuments',
  initialState,
  reducers: {
    resetDocumentsListReducer: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProjectDocumentsData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          documentsLoaded: false,
          documentsFetchFailed: false,
          documents: initialState,
        };
      })
      .addCase(fetchProjectDocumentsData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          documents: action.payload,
          documentsFetchFailed: false,
          documentsLoaded: true,
        };
      })
      .addCase(fetchProjectDocumentsData.rejected, (state) => {
        return {
          ...state,
          documentsFetchFailed: true,
          status: 'idle',
          documentsLoaded: true,
        };
      });
  },
});

export const getProjectDocuments = (state) => state.projectDocuments?.documents;
export const { resetDocumentsListReducer } = projectDocumentsSlice.actions;

export default projectDocumentsSlice.reducer;
